export default {
  idle: 'idle',
  processing: 'processing',
  uploading: 'uploading',
  saving: 'saving',
  failed: 'failed',
  success: 'success',
};
